import { DbLoadPositionByEan } from "../../../data/usecases/load-position-by-ean";
import { LoadPositionByEan } from "../../../domain/usecases/load-position-by-ean";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbLoadPositionByEan = (): LoadPositionByEan => {
  return new DbLoadPositionByEan(
    makeApiUrl("/position/ean"),
    makeAuthorizeHttpClientDecorator()
  );
};
